
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/le-cabinet",
      function () {
        return require("private-next-pages/le-cabinet/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/le-cabinet"])
      });
    }
  